/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Fotos() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Foto's</h1>
          <p>
            Foto's van de diverse Lekkveld vakanties maar ook evenementen zoals Sinterklaas en Lekkveld avonden zijn te vinden op op de fotosite 'Synology Photos'. De foto's zijn
            alleen toegankelijk met gebruikersnaam en wachtwoord. De gebruikersnaam is uiteraard 'lekkveld'. Om toegang tot het wachtwoord te krijgen zul je een aantal vragen
            moeten beantwoorden. Vragen waarop elke Lekkvelder het antwoord zal weten...
          </p>
          <p>
            Om het wachtwoord behorende bij de gebruiker 'lekkveld' te bemachtigen hoef je slechts onderstaande vragen te beantwoorden. Begin de antwoorden met een hoofdletter waar
            mogelijk, plak alles achter elkaar en voila, je weet het wachtwoord!{" "}
          </p>
          <ul>
            <li>Deel 1: In welke plaats woont Onze Marion?</li>
            <li>Deel 2: Uit welke studie aan de Universiteit Nijmegen is Lekkveld ontstaan?</li>
            <li>Deel 3: Welke cijfers staan op de onderste rij op de foto van de Signal groep 'Lekkveld'?</li>
          </ul>

          <p>
            <a
              href="https://photos.ladagevandoorn.nl/photo/?launchApp=SYNO.Foto.Sharing.AppInstance&app_name=SYNO.Foto.Sharing.AppInstance&photos_action=external_login&folderId=1&alias=photo#/signin"
              target="_new"
            >
              Inloggen
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Fotos;
